import { useParams } from "react-router-dom";
import { CallbackFunction, useSingleGenericAPI } from "../../../utils/genericAPI/useGenericAPI"
import {  addThumbnailStationAxios, BASE_URL_STATION } from "../services/stationsAPI"
import { Station, StationPatch } from "../types/stations.types"
import { useAuth } from "../../auth/hooks";
import { useMutation } from "react-query";
import { FileUrl } from "../../../common/components/molecule/FileListManager/FileListManager";
import {  AxiosError } from "axios";


/**
 * useSingleStation 
 *
 * @param id 
 * @returns 
 */
export default function useSingleStation(id?: string, hookId?: string) {
    const { stationId: idUrl } = useParams<{ stationId: string }>();
    const {setHeaderAuthToRequest} = useAuth()

    if (!id && !idUrl) {
        console.error("useSingleStation: stationId is required");
    }
    const idFound = id || idUrl;
    setHeaderAuthToRequest()

    const {singleQuery, updateQuery, deleteQuery} = useSingleGenericAPI<Station, StationPatch>({
        baseURL: BASE_URL_STATION,
        id: idFound || "",
        APIname: "stations",
        disableGet: !idFound,
        onSucessRefetchRessources:["hardwares"]
        })

    const addThumbnailStationQuery = useMutation({
        mutationFn: async ({fileUrl, callback}: {fileUrl: FileUrl, callback?: CallbackFunction<Station, AxiosError>}) => {
          addThumbnailStationAxios(idFound || "none", fileUrl).then((response) => {
            if (callback) {
              callback({result: response?.data})
            }
            return Promise.resolve(response?.data)
            
          }).catch((error) => {
            if (callback) {
              callback({error})
            }
            return Promise.reject(error)
          })
        }
    })
  return {
    stationId: idFound,
    singleStationQuery: singleQuery,
    updateStationQuery: updateQuery,
    deleteStationQuery: deleteQuery,
    addThumbnailStationQuery
   
  }
}
